export default __webpack_public_path__ + "static/11.06-e825cec72064f20d4c6aa61f43a84cca.png";